module.exports = __webpack_public_path__ + "static/media/ATMA-SPHERE MP-1 PRE AMPLIFIER.3567b8c4.png";